import { createFileRoute } from '@tanstack/react-router'
import { useIntlayer, useLocale } from 'react-intlayer'
import Body from '@/components/body'
import Heading from '@/components/heading'
import englishText from '@/components/md/en/privacy_policy.md?raw'
import japaneseText from '@/components/md/ja/privacy_policy.md?raw'
import ReactMarkdown from '@/components/react-markdown'

export const Route = createFileRoute('/term/privacy_policy/')({
  component: Page
})

function Page() {
  const content = useIntlayer('app')
  const { locale } = useLocale()
  return (
    <>
      <Heading>
        <Heading.Title>{content.label.privacy_policy}</Heading.Title>
      </Heading>
      <Body className='max-w-3xl mx-auto'>
        <ReactMarkdown>{locale === 'en' ? englishText : japaneseText}</ReactMarkdown>
      </Body>
    </>
  )
}
